import React from 'react'

import typography from '@bill/pathfinder.typography/dist/typography.module.scss'
import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'

import { PRODUCT_CONST_STRINGS } from '@sputnik/resources/constants'

const BillDescription = () => {
  const [_, makeTestId] = useNameFormatter('BillDescription')

  const { BILL_SPEND_AND_EXPENSE, BILL_DIVVY_CARD, BILL, DIVVY_PAY_LLC } = PRODUCT_CONST_STRINGS

  return (
    <div
      className={typography.triFontDesktopCaptionSmall}
      data-testid={makeTestId('')}
    >
      <FormattedMessage
        defaultMessage='{BILL} is a financial technology company, not a bank, and provides the software that brings you the features and solutions of {BILL_SPEND_AND_EXPENSE}. 
    WebBank, Cross River Bank, member FDIC, or Wex Bank are the issuers of the {BILL_DIVVY_CARD}.  
    References to "we," "us," and "our" refer to the applicable issuing bank and/or {DIVVY_PAY_LLC} as the servicer.'
        id='sputnik.BillDescription__lgmUrJ'
        values={{
          BILL,
          BILL_DIVVY_CARD,
          BILL_SPEND_AND_EXPENSE,
          DIVVY_PAY_LLC,
        }}
      />
    </div>
  )
}

export default BillDescription
